import { render, staticRenderFns } from "./DTPModal.vue?vue&type=template&id=28d461ec&scoped=true&"
import script from "./DTPModal.vue?vue&type=script&lang=js&"
export * from "./DTPModal.vue?vue&type=script&lang=js&"
import style0 from "./DTPModal.vue?vue&type=style&index=0&id=28d461ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d461ec",
  null
  
)

export default component.exports